<script setup>
import {ref} from "vue";
import useGrid from "@/composables/useGrid";
import marketsService from "@/services/markets.service";
import TablePager from "@/components/TablePager.vue";
import {getLogo} from "@/helpers/logo";
import {getNoun} from "../../helpers/string";

const props = defineProps(['searchType','searchObjectId']);
const corporate = ref(null);

const {gridParams, gridMethods, items} = useGrid(getPartnershipsList, 7);

const showModal = ref(false);

function getPartnershipsList(pageParams) {
    pageParams.filters = props;

    return marketsService.getPartnershipsIndex(corporate.value.id, pageParams);
}

function open(corporateData) {
    corporate.value = corporateData;
    showModal.value = true;
    gridMethods.resetList();
}

defineExpose({
    open
});
</script>

<template>
    <b-modal v-if="corporate" v-model="showModal" :title="`${corporate.name}'s Partnerships`" modal-class="modal-md modal-blue" :hide-footer="!items.length">
        <div class="modal-blue__top">
            <b>{{gridParams.totalRowsCount}} {{getNoun('partnership', gridParams.totalRowsCount)}}</b>

            <a :href="`/startups?client=${corporate.name}`" target="_blank" class="modal-blue__search"> Open in Search</a>
        </div>

        <ul class="list-partner">
            <li v-for="partnership in items" :key="partnership.id">
                <div class="list-partner__image">
                    <img :src="getLogo(partnership.startup_logo)" alt="Logo" width="60" height="60"/>
                </div>
                <div style="flex: 1">
                    {{partnership.summary[0]}}

                    <template v-if="partnership.summary.length > 1">
                        <a :href="`/startups/${partnership.startup_id}`" target="_blank">{{partnership.startup_name}}</a> {{partnership.summary[1]}}
                    </template>
                </div>
            </li>
        </ul>

        <template #modal-footer>
            <TablePager
                v-if="items.length"
                :pages-count="gridParams.pagesCount"
                :init-page="gridParams.currentPage"
                @changePage="gridMethods.changePage"
            />
        </template>
    </b-modal>
</template>

<style scoped>

</style>
